import React from 'react';
import { Option, Question } from '../../types';
import { renderSanitizedHtml } from '../../utils/sanitizeHtml';

interface FormScaleProps {
  question: Question;
  handleChange: (questionKey: string, answer: Option[]) => void;
  errors: Record<string, string>;
  setErrors?: (value: Record<string, string>) => void;
  disabled: boolean;
}

const FormScale: React.FC<FormScaleProps> = ({
  question,
  handleChange,
  errors,
  setErrors,
  disabled,
}) => {
  const numOptions = question.scale_num_options || 5;
  const options = Array.from({ length: numOptions }, (_, i) => i + 1);

  const handleScaleChange = (value: number) => {
    const option: Option = {
      guid: `scale_${value}`,
      text: value.toString(),
    };
    handleChange(question.question_key, [option]);
    if (setErrors && errors[question.question_key]) {
      const next = { ...errors };
      delete next[question.question_key];
      setErrors(next);
    }
  };

  const selectedValue = question.answer?.[0]?.text
    ? parseInt(question.answer[0].text as string)
    : undefined;

  return (
    <div className='scale-container'>
      <div className='scale-wrapper'>
        <div className='scale-content'>
          <div className='scale-buttons'>
            {options.map((value) => (
              <div key={value} className='scale-option'>
                <input
                  type='radio'
                  id={`${question.question_key}_${value}`}
                  name={question.question_key}
                  value={value}
                  checked={selectedValue === value}
                  onChange={() => handleScaleChange(value)}
                  disabled={disabled}
                />
                <label htmlFor={`${question.question_key}_${value}`}>{value}</label>
              </div>
            ))}
          </div>

          <div className='scale-labels'>
            {question.scale_min_text && (
              <div className='scale-label scale-min-label'>
                {renderSanitizedHtml(question.scale_min_text)}
              </div>
            )}

            <div className='scale-label-spacer'></div>

            {question.scale_max_text && (
              <div className='scale-label scale-max-label'>
                {renderSanitizedHtml(question.scale_max_text)}
              </div>
            )}
          </div>
        </div>
      </div>

      {errors[question.question_key] && (
        <div className='error-message'>{errors[question.question_key]}</div>
      )}
    </div>
  );
};

export default FormScale;
